import alt from '../alt';

class PaymentActions {
    constructor() {
        this.generateActions('getSuccess');
    }
}

export default alt.createActions(PaymentActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/PaymentActions.js
 **/